import { createFileRoute } from "@tanstack/react-router";
import {
  PasswordResetSetPassword,
  PasswordResetError,
  PasswordResetLoading,
} from "@pages/password-reset/password-reset-set-password/password-reset-set-password";

import { usePasswordResetDataStore } from "src/services/password-reset-data-store";

export const Route = createFileRoute(
  "/_passwordreset-layout/reset/$uidb64/set-password",
)({
  component: PasswordResetSetPassword,
  errorComponent: PasswordResetError,
  pendingComponent: PasswordResetLoading,
  loader: (ctx) => {
    const currentToken =
      usePasswordResetDataStore.getState().passwordResetToken;
    // throw error means errorComponent will be shown
    if (currentToken === undefined) {
      throw new Error("Password reset token not found");
    }
  },
});
